<div *ngIf="!editTabOnlyMode" class="seller-snapshot">

    <div *ngIf="seller && (histSeller || !isDateUsed) && !isTabChanging">
        <dx-form #snapshotForm [items]="cleanedFormItems" labelLocation="top" [colCount]="formColCount">
            <div *dxTemplate="let data of horizontalLineTemplateName">
                <hr>
            </div>
            <div *dxTemplate="let data of datasourceGridTemplateName">
                <ng-container *ngVar="snapshotDatasources[data.dataField] as ds">
                    <core-data-grid
                        [dataSource]="ds?.dataSource"
                        [columns]="ds?.columns"
                        [props]="ds?.props">
                    </core-data-grid>
                </ng-container>
            </div>
            <div *dxTemplate="let data of labelTemplateName">
                <span id="label-{{data.dataField}}" class="dx-field-item-label-text">{{data.text}}</span>
                <dx-tooltip *ngIf="data.editorType === 'dxLookup'"
                    target=".dx-field-item:not(.dx-field-item-has-group):has(#label-{{data.dataField}}) .dx-dropdowneditor-active"
                    [position]="{my: 'bottom right', at: 'top right', offset: { y: 6 }}"
                    showEvent="dxclick">
                    <div class="seller-snapshot-dates-tooltip">
                        {{getEffectiveDateHintText(data)}}
                    </div>
                </dx-tooltip>
                <dx-tooltip *ngIf="data.editorType === 'dxTextBox' || data.editorType === 'dxTextArea' || data.editorType === 'dxNumberBox'"
                    target=".dx-field-item:not(.dx-field-item-has-group):has(#label-{{data.dataField}}) .dx-texteditor-input"
                    [position]="{my: 'bottom right', at: 'top right', offset: { y: 6 }}"
                    showEvent="focusin">
                    <div class="seller-snapshot-dates-tooltip">
                        {{getEffectiveDateHintText(data)}}
                    </div>
                </dx-tooltip>
            </div>
        </dx-form>
        <div>
            <dx-button text="Save Changes" class="dx-button dx-button-default save-snapshot-changes-button" (onClick)="submitForm()" [visible]="formItems?.length > 0 && isSnapshotEditable"></dx-button>
        </div>
    </div>
    <div *ngIf="!seller && pageLoaded" class="inactive-snapshot-message">
        Please select an account to view snapshot.
    </div>
    <div *ngIf="seller && !histSeller && !snapshotRefreshing && isDateUsed" class="inactive-snapshot-message">
        Account is inactive at the specified date.
    </div>

</div>

<dx-popup
    [showTitle]="true"
    [title]="(editTabOnlyMode ? 'Edit Tab' : 'Edit Account Snapshot Layout')"
    [(height)]="popupHeight"
    [minHeight]="minPopupHeight"
    [width]="(editTabOnlyMode ? 520 : 700)"
    [minWidth]="520"
    [showCloseButton]="false"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    (onResize)="onResizePopup($event)"
    container=".dx-viewport"
    [position]="{
        my: 'top',
        at: 'top',
        of: '.main-scroll-view .dx-scrollview-content',
        offset: { y: 30 }
    }"
    [(visible)]="editPopupVisible">

    <div class="seller-snapshot-editor">
        <div class="tab-properties-section">
            <div class="tab-name">
                <div class="column-label">Name</div>
                <dx-text-box [(value)]="sellerLayout.name" (input)="sellerLayout.name = $event.target.value;" (onKeyDown)="onLayoutNameKeyDown($event)"></dx-text-box>
            </div>
            <div class="tab-is-default">
                <div class="column-label">Default View</div>
                <dx-check-box [(value)]="sellerLayout.isDefault"></dx-check-box>
            </div>
        </div>

        <div *ngIf="!editTabOnlyMode">
            <dx-box direction="row">
                
                <dxi-item [ratio]="1" class="field-list">
            
                    <div class="column-label">Fields</div>
    
                    <dx-data-grid
                        #fieldGrid
                        [dataSource]="snapshotFields"
                        [showColumnHeaders]="false"
                        [height]="popupGridHeight">
                        <dxo-row-dragging
                            [data]="snapshotFields"
                            group="snapshotFieldsGroup">
                        </dxo-row-dragging>
                        <dxo-scrolling mode="standard"></dxo-scrolling>
                        <dxo-paging [enabled]="false"></dxo-paging>
                        <dxi-column dataField="caption" dataType="string" cellTemplate="captionTemplate">
                            <div *dxTemplate="let cellInfo of 'captionTemplate'" class="{{(cellInfo.data.visible ? '' : 'unavailable-field')}}">
                                {{cellInfo.data.caption}}
                            </div>
                        </dxi-column>
                        <dxi-column dataField="visible" [visible]="false" dataType="boolean"></dxi-column>
                        <dxi-column dataField="group" [visible]="false" dataType="number" [groupIndex]="0" groupCellTemplate="groupTemplate">
                            <div *dxTemplate="let data of 'groupTemplate'">
                                {{getGroupText(data.value)}}
                            </div>
                        </dxi-column>
                    </dx-data-grid>
            
                </dxi-item>
            
                <dxi-item [ratio]="1" class="field-list">
                    
                    <div class="column-label">Form Configuration</div>
            
                    <dx-data-grid
                        #formGrid
                        [dataSource]="formItems"
                        [height]="popupGridHeight"
                        [showColumnHeaders]="false"
                        (onToolbarPreparing)="onFormGridToolbarPreparing($event)"
                        (onSaved)="onFormGridSaved($event)"
                        (onRowExpanding)="onFormGridRowExpanding($event)"
                        (onInitNewRow)="onFormGridInitNewRow($event)">
                        <dxo-scrolling mode="standard"></dxo-scrolling>
                        <dxo-paging [enabled]="false"></dxo-paging>
                        <dxo-editing
                            mode="form"
                            [allowUpdating]="true"
                            [allowAdding]="true"
                            [allowDeleting]="true">
                            <dxo-form [customizeItem]="customizeFormItem">
                                <dxi-item dataField="label.text" [colSpan]="2" [label]="{ text: 'Field' }" [editorOptions]="{ readOnly: true }"></dxi-item>
                                <dxi-item dataField="colSpan" [colSpan]="1" editorType="dxNumberBox" [editorOptions]="{ showSpinButtons: true }"></dxi-item>
                                <dxi-item dataField="colCount" [colSpan]="1" editorType="dxNumberBox" [editorOptions]="{ showSpinButtons: true }"></dxi-item>
                            </dxo-form>
                        </dxo-editing>
                        <dxo-row-dragging
                            [data]="formItems"
                            group="snapshotFieldsGroup"
                            [allowReordering]="true"
                            [onAdd]="onAddFormItem"
                            [onRemove]="onRemoveFormItem"
                            [onReorder]="onReorderFormItem">
                        </dxo-row-dragging>
                        <dxi-column dataField="label.text" dataType="string" cellTemplate="labelCellTemplate">
                            <div *dxTemplate="let cellInfo of 'labelCellTemplate'" [ngClass]="{'group-item': cellInfo.data.itemType === 'group', 'simple-item': cellInfo.data.itemType !== 'group'}">
                                <div class="field-name">{{cellInfo.data.label.text}}</div>
                            </div>
                        </dxi-column>
                        <dxi-column dataField="colSpan" caption="Column Span" dataType="number" [visible]="false"></dxi-column>
                        <dxi-column dataField="colCount" caption="Column Count" dataType="number" [visible]="false"></dxi-column>
                        <dxi-column dataField="itemType" [visible]="false"></dxi-column>
                        <dxi-column dataField="dataField" [visible]="false"></dxi-column>
                        <dxi-column dataField="height" [visible]="false"></dxi-column>
                        <dxi-column dataField="gridColumns" [visible]="false"></dxi-column>
                        <dxi-column dataField="gridFilterObject" [visible]="false"></dxi-column>
                        <dxi-column type="buttons" [width]="70" alignment="right">
                            <dxi-button name="delete" [visible]="isDeleteButtonVisible"></dxi-button>
                            <dxi-button name="edit-grid-config" icon="edittableheader" hint="Edit Grid Configuration" [visible]="isGridConfigButtonVisible" [onClick]="onEditGridConfig"></dxi-button>
                            <dxi-button name="edit" [visible]="isEditButtonVisible"></dxi-button>
                        </dxi-column>
                        <dxo-master-detail [enabled]="true" template="formGroupTemplate"></dxo-master-detail>
                        <div *dxTemplate="let groupItem of 'formGroupTemplate'">
                            <dx-data-grid
                                [dataSource]="groupItem.data.items"
                                [showColumnHeaders]="false"
                                (onSaved)="onFormGridSaved($event)"
                                (onInitNewRow)="onFormGridInitNewRow($event)">
                                <dxo-scrolling mode="standard"></dxo-scrolling>
                                <dxo-paging [enabled]="false"></dxo-paging>
                                <dxo-editing
                                    mode="form"
                                    [allowUpdating]="true"
                                    [allowDeleting]="true">
                                    <dxo-form [customizeItem]="customizeFormItem">
                                        <dxi-item dataField="label.text" [colSpan]="2" [label]="{ text: 'Field' }" [editorOptions]="{ readOnly: true }"></dxi-item>
                                        <dxi-item dataField="colSpan" [colSpan]="1" editorType="dxNumberBox" [editorOptions]="{ showSpinButtons: true }"></dxi-item>
                                        <dxi-item dataField="colCount" [colSpan]="1" editorType="dxNumberBox" [editorOptions]="{ showSpinButtons: true }"></dxi-item>
                                    </dxo-form>
                                </dxo-editing>
                                <dxo-row-dragging
                                    [data]="groupItem.data.items"
                                    group="snapshotFieldsGroup"
                                    [allowReordering]="true"
                                    [onAdd]="onAddFormItem"
                                    [onRemove]="onRemoveFormItem"
                                    [onReorder]="onReorderFormItem">
                                </dxo-row-dragging>
                                <dxi-column dataField="label.text" dataType="string" cellTemplate="labelCellTemplate">
                                    <div *dxTemplate="let cellInfo of 'labelCellTemplate'" class="{{cellInfo.data.itemType === 'group' ? 'group-item' : 'simple-item'}}">
                                        {{cellInfo.data.label.text}}
                                    </div><dxo-form-item [colSpan]="2" [label]="{ text: 'Field' }" [editorOptions]="{ readOnly: true }"></dxo-form-item>
                                </dxi-column>
                                <dxi-column dataField="colSpan" caption="Column Span" dataType="number" [visible]="false"></dxi-column>
                                <dxi-column dataField="colCount" caption="Column Count" dataType="number" [visible]="false"></dxi-column>
                                <dxi-column dataField="itemType" [visible]="false"></dxi-column>
                                <dxi-column dataField="dataField" [visible]="false"></dxi-column>
                                <dxi-column dataField="height" [visible]="false"></dxi-column>
                                <dxi-column dataField="gridColumns" [visible]="false"></dxi-column>
                                <dxi-column dataField="gridFilterObject" [visible]="false"></dxi-column>
                                <dxi-column type="buttons" [width]="50">
                                    <dxi-button name="edit-grid-config" icon="edittableheader" hint="Edit Grid Configuration" [visible]="isGridConfigButtonVisible" [onClick]="onEditGridConfig"></dxi-button>
                                    <dxi-button name="edit" [visible]="isEditButtonVisible"></dxi-button>
                                </dxi-column>
                            </dx-data-grid>
                        </div>
                    </dx-data-grid>
                    
                </dxi-item>
    
            </dx-box>
        </div>
        
    </div>
    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="editLayoutPopupSaveButtonOptions"></dxi-toolbar-item>
    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="editLayoutPopupCancelButtonOptions"></dxi-toolbar-item>
    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="before" [options]="editLayoutPopupDeleteButtonOptions"></dxi-toolbar-item>
</dx-popup>

<app-seller-snapshot-grid-config-popup
    #gridConfigPopup
    [visible]="editGridConfigPopupVisible"
    [sellerLayout]="sellerLayout"
    [masterMapping]="masterMapping"
    [columnMappings]="columnMappings"
    (onSave)="saveEditGridConfigPopup()"
    (onCancel)="closeEditGridConfigPopup()">    
</app-seller-snapshot-grid-config-popup>
